<template>
  <div class="pc_supply">
    <div class="w main">
      <div class="main_left">
        <Upload/>
        <div class="hot">
          <h3 class="hot_title">热门推荐</h3>
          <Wonderful/>
        </div>
      </div>
      <div class="main_right">
        <div class="supply_cut_title">
           <span :class="selected=='gong'?'supply_active':''" @click="supplyCut('gong')">
             供应信息
           </span>
           <span :class="selected=='xu'?'supply_active':''" @click="supplyCut('xu')">
             采购信息
           </span>
        </div>
        <div class="nav_vessel">
          <ul :class="down?'nav_list up':'nav_list '">
            <li :class="barActive== i?'nav_item nav_active':'nav_item'" v-for="(item,i) in barList" :key="i" @click="url(item,i)">
              {{item.name}}
            </li>
            <li></li>
            <li></li>
            <li></li>
            
          </ul>
          <button :class="down?'down downActive':'down' " @click="()=>{this.down=!this.down}">
            展开
          </button>
        </div>
        <SupplyList :data='data' @supplyCut="reqSupplyCut"/>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from './upload'
import Wonderful from './wonderful'
import SupplyList from './supplyList'
import { reqSupply } from "../../../api";
export default {
  props:{
    barList:Array
  },
  components:{
    Upload,
    Wonderful,
    SupplyList
  },
  data(){ 
    return{
      data:{
        list:Array,
        listnum:Number,
        pageListnum:Number,
        page:Number,
      },
      selected:"",//大标题
      sortid:'',
      barActive:0,
      xiaobiao:false,
      down:false,//导航下拉切换
    }
  },
  mounted(){
    if (sessionStorage.getItem('selected')) {//首页 更多
      this.selected = JSON.parse(sessionStorage.getItem('selected'))
      this.reqSupplyCut(this.selected)
      sessionStorage.removeItem('selected')
      return
    }
    if (sessionStorage.getItem('negotiation')) {//首页 洽谈
      let obj = JSON.parse(sessionStorage.getItem('negotiation'))
      this.selected = obj.key
      this.reqSupplyCut(obj.key)
      
      sessionStorage.removeItem('negotiation')
      return
    }
    this.reqSupplyCut('gong')
  },
  methods:{
    supplyCut(item){//大类切换
      this.xiaobiao=false
      this.down = false
      this.reqSupplyCut(item)
    },
    async reqSupplyCut(selected,page,sortid,falg=true,liviao=false){// 请求列表
      if (liviao) {
        selected=this.selected
        sortid=this.sortid
      }else{
        this.selected=selected
      }
      this.$store.dispatch('release',selected)
      const response = await reqSupply(selected,page,sortid)
      if(response.code==0){
        if (falg) {
          this.data.list=response.resilt
          if (!this.xiaobiao) {
            this.barActive = 0
          }
        }else{
          this.data.list.push(...response.resilt)
        }
        this.data.pageListnum=response.pagelistnum
        this.data.page = response.thispage
        this.data.listnum = response.listnum
      }else{
        this.data.list=[]
      }
    },
    url(item,i){
      this.barActive = i
      this.xiaobiao=true
      this.sortid = item.sortid
      if (item.sortid!=0) {
        this.reqSupplyCut(this.selected,1,item.sortid)
      }else{
        this.reqSupplyCut(this.selected,1)
      }
      this.$store.dispatch("barAmend",i)
    },
  }

}
</script>

<style scoped>
  .pc_supply{
    padding-top: 100px;
    width: 100%;
    background-color: pink;
    background-image: url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/exhibitorBg.jpg');
    background-repeat: no-repeat;
    background-size: 100%;
    background-color: #f2f2f2;
  }
  .w{
    width: 100%;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    /* overflow: hidden; */
  }
  .main{
    display: flex;
  }
  .main_left{
    width: 25%;
    /* width: 300px; */
    /* background-color: white; */
    /* overflow: hidden; */
  }
  .hot{
    padding-left: 30px;
    padding-right: 30px;
    background-color: white;
  }
  .hot_title{
    text-align: center;
    line-height: 66px;
    font-size: 20px;
    color: #008baf;
  }

  /* right start */
  .main_right{
    width: calc( 100% - 20px - 25%);
    margin-left: 20px;
  }
  .supply_cut_title{
    line-height: 90px;
    font-size: 20px;
    color: #333;
    background-color: white;
    margin-bottom: 2px;
    font-weight: 600;
  }
  .supply_cut_title >span {
    display: inline-block;
    text-align: center;
    max-width: 200px;
    width: 100%;
    cursor: pointer;
  }
  .supply_cut_title >span:hover,
  .supply_active{
    color: #008baf;
  }

  .nav_vessel{
    width: 100%;
    position: relative;
    padding: 34px 118px 34px 62px;
    background-color: white;
    margin-bottom: 2px;
  }
  .nav_list{
   display: flex; 
   flex-wrap: wrap;
   justify-content: space-between;
   height: 50px;
   overflow: hidden;
  }
  .up{
    height: auto;
  }
  .nav_list>li{
    min-width: 128px;
  }
  .nav_item{
    line-height: 48px;
    /* padding-left: 16px;
    padding-right: 16px; */
    text-align: center;
    color: #666;
    background-color: #f2f2f2;
    font-size: 16px;
    border-radius: 6px;
    margin-bottom: 6px;
    cursor: pointer;
  }
  .nav_item:hover,
  .nav_active{
    color: #008baf;
    background-color: #a3e7f9;
  }
  
  .down{
    position: absolute;
    right: 10px;
    top: 42px;
    width: 78px;
    line-height: 34px;
    border-radius: 18px;
    box-sizing: border-box;
    outline: none;
    border: none;
    border:1px solid #999999;
    color: #999999;
    background-color: white;
    cursor: pointer;
  }
  .downActive,
  .down:hover{
    color: #008baf;
    border-color: #008baf;
  }
  
  
  /* right end */
</style>